import React from "react";

interface SkeletonRowsProps {
  columns: number;
  rows?: number;
}

const SkeletonRows: React.FC<SkeletonRowsProps> = ({ columns, rows = 5 }) => (
  <>
    {Array.from({ length: rows }).map((_, r) => (
      <tr className="ds-skeleton-row" key={r}>
        {Array.from({ length: columns }).map((__, c) => (
          <td key={c}>
            <div className="ds-skeleton" style={{ height: 14, width: c === 0 ? "70%" : "50%" }} />
          </td>
        ))}
      </tr>
    ))}
  </>
);

export default SkeletonRows;
